import styled from '@emotion/styled'
import { TicketSwap, CloseAlt } from '@ticketswap/solar/icons'
import { color, Text, space, radius, fontSize, device } from '@ticketswap/solar'
import PropTypes from '~/lib/propTypes'
import { SMART_BANNER_TAPPED, SMART_BANNER_VIEWED } from '~/lib/tracking-events'
import { useEffect, useState } from 'react'
import { track } from '~/utils/analytics'
import useStats from '~/hooks/useStats'
import { setCookie } from 'cookies-next'

const Container = styled.div`
  background-color: ${color.elevatedBackground};
  grid-template-columns: ${space[16]} ${space[40]} 1fr auto;
  padding-block: ${space[12]};
  padding-inline: ${space[12]};
  grid-gap: ${space[12]};
  align-items: center;
  display: ${props => (props.menuShown ? 'none' : 'grid')};
`

const LogoBlock = styled.div`
  width: ${space[40]};
  height: ${space[40]};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${color.earth};
  border-radius: ${radius.lg};

  > span {
    color: white;
  }
`

const Label = styled(Text)`
  font-size: ${fontSize[14]};
  margin-block-end: -${space[4]};

  @media ${device.mobileM} {
    font-size: ${fontSize[16]};
  }
`

const Stars = styled.div`
  display: flex;
  gap: ${space[8]};
  align-items: center;
`

const Reviews = styled(Text)`
  font-size: ${fontSize[12]};
  color: ${color.foregroundMuted};
  margin-block-start: ${space[4]};
`

const Button = styled.button`
  color: ${color.earth};
`

const SmartBanner = ({ menuShown, hideBanner, t, setHideSmartBanner }) => {
  const [tracked, setTracked] = useState(false)

  const { appStoreStars, appStoreReviewsCount } = useStats({
    t,
  })

  useEffect(() => {
    if (hideBanner || tracked) return

    track(SMART_BANNER_VIEWED)
    setTracked(true)
  }, [hideBanner, tracked])

  if (hideBanner) return null

  const handleView = async () => {
    await track(SMART_BANNER_TAPPED)
    window.location.href =
      'itms-apps://apps.apple.com/app/id932337449?pt=76205801&ct=smart_banner&mt=12'
  }

  const handleClose = () => {
    setHideSmartBanner(true)
    setCookie('hideSmartBanner', 1, { secure: true, sameSite: 'lax' })
  }

  return (
    <Container menuShown={menuShown}>
      <button onClick={handleClose}>
        <CloseAlt color={color.foregroundSubtle} size={16} />
      </button>

      <LogoBlock>
        <TicketSwap size={32} />
      </LogoBlock>

      <div>
        <Label as="p">TicketSwap iPhone App</Label>
        <Stars>
          <span>{appStoreStars}</span>
          <Reviews>{appStoreReviewsCount}+ reviews</Reviews>
        </Stars>
      </div>

      <Button onClick={handleView}>Download</Button>
    </Container>
  )
}

SmartBanner.propTypes = {
  menuShown: PropTypes.bool.isRequired,
  hideBanner: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  setHideSmartBanner: PropTypes.func.isRequired,
}

export default SmartBanner
